import { APIURL } from "./config";
import axios from "axios";
import { toast } from "react-toastify";
import {
  AFFILIATE_LIST,
  AFFILIATE_UPDATE,
  AFFILIATE_DELETE,
  LOADING,
  NOT_FOUND,
} from "./type";

export const affiliateList = () => async (dispatch) => {
  dispatch({
    type: LOADING,
    payload: "",
  });
  const token = localStorage.getItem("token");
  var config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  try {
    const res = await axios.get(`${APIURL}/api/v1/affiliate`, config);
    dispatch({
      type: AFFILIATE_LIST,
      payload: res.data,
    });
    if (res?.data?.data?.affiliate?.length === 0) {
      dispatch({
        type: NOT_FOUND,
        payload: "",
      });
    }
  } catch (error) {
    toast.error(error?.response?.data?.message);
  }
};

export const updateAffiliateStatus = (id, status) => async (dispatch) => {
  const token = localStorage.getItem("token");
  var config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  try {
    const response = await axios.patch(
      `${APIURL}/api/v1/affiliate/${id}`,
      { status },
      config
    );
    dispatch({ type: AFFILIATE_UPDATE, payload: response?.data });
    toast.success("Application status updated successfully!");
  } catch (error) {
    toast.error(error?.response?.data?.message);
  }
};

export const affiliateDelete = (id) => async (dispatch) => {
  const token = localStorage.getItem("token");
  var config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  try {
    if (window.confirm("Do you want to delete this application?")) {
      const res = await axios.delete(`${APIURL}/api/v1/affiliate/${id}`, config);
      toast.success("Application Deleted Successfully!");
      dispatch({
        type: AFFILIATE_DELETE,
        payload: res.data,
      });

      return { success: true };
    }
  } catch (error) {
    toast.error(error?.response?.data?.message);
  }
};
